<template>
  <div :class="['password-field', wrapperClass]" :style="wrapperStyle">
    <slot
      :inputType="inputType"
      :inputStyle="resolvedInputStyle"
      :isVisible="isVisible"
    />

    <button
      :aria-label="buttonLabel"
      :class="['password-toggle', buttonClass]"
      :style="buttonStyle"
      type="button"
      @click="toggleVisibility"
    >
      {{ buttonLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PasswordVisibilityToggle',

  props: {
    buttonClass: {
      type: [String, Array, Object],
      default: ''
    },
    buttonStyle: {
      type: [String, Array, Object],
      default: null
    },
    hideLabel: {
      type: String,
      default: 'Hide password'
    },
    inputPaddingRight: {
      type: String,
      default: '8rem'
    },
    inputStyle: {
      type: [String, Array, Object],
      default: null
    },
    showLabel: {
      type: String,
      default: 'Show password'
    },
    wrapperClass: {
      type: [String, Array, Object],
      default: ''
    },
    wrapperStyle: {
      type: [String, Array, Object],
      default: null
    }
  },

  data() {
    return {
      isVisible: false
    }
  },

  computed: {
    buttonLabel() {
      return this.isVisible ? this.hideLabel : this.showLabel
    },
    inputType() {
      return this.isVisible ? 'text' : 'password'
    },
    resolvedInputStyle() {
      return [
        {
          paddingRight: this.inputPaddingRight
        },
        this.inputStyle
      ]
    }
  },

  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible
    }
  }
}
</script>

<style scoped lang="scss">
.password-field {
  position: relative;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 1rem;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #404041;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.password-toggle:focus {
  outline: none;
}
</style>